import { render, staticRenderFns } from "./RightDisplayArea.vue?vue&type=template&id=2d868364&scoped=true"
import script from "./RightDisplayArea.vue?vue&type=script&lang=js"
export * from "./RightDisplayArea.vue?vue&type=script&lang=js"
import style0 from "./RightDisplayArea.vue?vue&type=style&index=0&id=2d868364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d868364",
  null
  
)

export default component.exports